import React from 'react';
import { Button } from './Button';
import { Modal } from './Modal';

export interface AlertCompletedModalProps {
  isOpen: boolean;
  patientName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

/**
 * AlertCompletedModal - AXIS076 AE Validation Workflow
 * 
 * Second checkpoint modal for ACC Accredited Employer referrals.
 * Prompts staff to confirm alert has been set in Indici.
 * 
 * - Yes → Referral transitions to completed status
 */
export const AlertCompletedModal: React.FC<AlertCompletedModalProps> = ({
  isOpen,
  patientName,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      isLoading={isLoading}
      style={{ maxWidth: '500px' }}
    >
      <div className="modal-header">
        <h3>Alert Completed?</h3>
      </div>
      <div className="modal-body">
        <p>
          <strong>Patient:</strong> {patientName}
        </p>
        
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <p>
            Has the alert been set in Indici for this referral?
          </p>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>
            Confirming will mark this referral as completed.
          </p>
        </div>
      </div>
      
      <div className="modal-footer">
        <Button
          variant="secondary"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={onConfirm}
          disabled={isLoading}
          isLoading={isLoading}
        >
          Yes - Confirm
        </Button>
      </div>
    </Modal>
  );
};
